import Store from 'store/store';

Store.on('TOGGLE_NEWSLETTER_BANNER', (close) => {
	let store = Store.get();
	if (typeof close === 'undefined') {
		close = store.signupBanner?.open;
	}
	let newState = { open: !close };
	if (!store.signupBanner) {
		store.set({ signupBanner: newState });
	} else {
		store.signupBanner.set(newState);
	}
});
